// extracted by mini-css-extract-plugin
module.exports = {"companyItem":"CompanyItem_companyItem__1fa3N","companyItem__title":"CompanyItem_companyItem__title__2keln","companyItem__button":"CompanyItem_companyItem__button__3YKBn"};